import React from 'react';
import PropTypes from 'prop-types';
import CrmQuote from '../../../../classes/CrmQuote';
import BasicQuoteInformation from '../../BasicQuoteInformation/BasicQuoteInformation';

function WrongRoleQuoteScreen({ quote, loadError }) {
  return (
    <div>
      <p>
        Basic information about your quote is listed below.
        Additional details and placing a payment are restricted by your user role.
      </p>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicQuoteInformation
            quoteNumber={quote.quoteNumber}
            quoteStatus={quote.statusType}
            createdAt={quote.createdAtDisplay}
            expiresAt={quote.expiresAtDisplay}
            loadError={loadError}
          />
        </div>

        <div className="col-lg-6 col-sm-12">
          <div className="card bg-light" style={{ minHeight: '4rem' }}>
            <div className="card-body">
              <div className="pb-3">
                <ul className="list-unstyled">
                  <li>
                    <p>
                      You need an Administrator or Billing user role
                      to access this record. Please ask an administrator
                      or provisioner on your account to change your user role.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

WrongRoleQuoteScreen.propTypes = {
  quote: PropTypes.shape(CrmQuote).isRequired,
  loadError: PropTypes.bool.isRequired,
};

export default WrongRoleQuoteScreen;
